import { useParams } from '@tanstack/react-router'
import { useRolodexEntries } from 'features/rolodex'
import { useMemo } from 'react'
import { RolodexEntryType } from 'types'

export interface ChatbotContextInfo {
  organizationIds: string[]
  siteId: string | undefined
  url: string
  pageTitle: string
  urlParams: Record<string, unknown>
  urlSearchParams: Record<string, unknown>
}

export const useChatbotContext = (
  urlSearchParams: Record<string, unknown>
): ChatbotContextInfo => {
  const params = useParams({ strict: false })
  const siteId = params.siteID

  const { entries: sites } = useRolodexEntries(
    siteId
      ? {
          ids: [siteId],
          type: RolodexEntryType.SITE,
        }
      : undefined
  )

  const organizationIds = useMemo(() => {
    if (!sites || sites.length === 0) return []
    const site = sites[0]
    const orgId = site?.tags?.organization
    return orgId ? [orgId] : []
  }, [sites])

  return {
    organizationIds,
    siteId,
    url: window.location.href,
    pageTitle: document.title,
    urlParams: params,
    urlSearchParams,
  }
}
